import { ReactElement } from 'react'

import FindViagensComVPOImpl from 'modules/valePedagio/domain/usecases/FindViagensComVPO'
import ValePedagioRepository from 'modules/valePedagio/infra/repositories/ValePedagioRepository'
import ListViagens from 'modules/valePedagio/pages/ListViagens'

export const ListViagensFactory = (): ReactElement => {
  const repository = new ValePedagioRepository()
  const usecase = new FindViagensComVPOImpl(repository)

  return <ListViagens findViagensComVPO={usecase} />
}
